import { InfiniteData } from '@tanstack/react-query';
import { PageDataWithCount } from '../../useInfiniteDataQuery.types';

const mapPagesAt = (
  data: InfiniteData<PageDataWithCount>,
  pageIndex: number,
  transform: (page: PageDataWithCount, currentPageIndex: number) => PageDataWithCount,
): InfiniteData<PageDataWithCount> => ({
  ...data,
  pages: data.pages.map((page, currentPageIndex) => {
    if (currentPageIndex !== pageIndex) {
      return page;
    }
    return transform(page, currentPageIndex);
  }),
});

const findIndexesByGlobalIndex = (
  data: InfiniteData<PageDataWithCount> | undefined,
  index: number,
): { pageIndex: number; itemIndexInPage: number } | null => {
  if (!data || !data.pages || index < 0) {
    return null;
  }

  let acc = 0;
  const pageIndex = data.pages.findIndex((page) => {
    const len = page?.data?.length ?? 0;
    acc += len;
    return index < acc;
  });

  if (pageIndex === -1) {
    return null;
  }

  const pageLen = data.pages[pageIndex]?.data?.length ?? 0;
  const prevAcc = acc - pageLen;

  return { pageIndex, itemIndexInPage: index - prevAcc };
};

export const useMutateInfiniteDataQueryUtils = {
  mapPagesAt,
  findIndexesByGlobalIndex,
};
